import React, { Suspense } from 'react'
import { RowsSkeletonLoader } from '@node-space/ui-components'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { createMFELazy } from 'utils/createMFELazy'

const WebhooksLazy = createMFELazy(() => import('webhooks/Webhooks'), {
  mfeName: 'Webhooks',
  testId: 'webhooks-mfe-error',
})

export const WebhooksPage = () => {
  return (
    <Suspense fallback={<RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />}>
      <WebhooksLazy bffUrl={process.env.VITE_BASE_URL} />
    </Suspense>
  )
}
